import { update } from 'features/auth/auth.slice';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useUpdateMeMutation } from 'services/user/user.endpoint';
import { UpdateUserPayload } from 'services/user/user.types';
import { useApiToast } from 'components/Toaster';
export const useUserInfo = () => {
    const { showApiToast, showErrorToast } = useApiToast();
    const [lastUpdatedUserLabel, setLastUpdatedUserLabel] = useState<string>('');

    const [
        updateMe,
        { isLoading: isUpdateMeLoading, isError: isUpdateMeError, isSuccess: isUpdateMeSuccess, error: updateMeError, data: updateMeData }
    ] = useUpdateMeMutation();

    const dispatch = useDispatch();

    const handleUpdateUser = async (data: UpdateUserPayload) => {
        if (!data) return;
        setLastUpdatedUserLabel(data.fullname || '');
        const response = await updateMe(data);
        if (response.data) {
            dispatch(update(response.data.data));
        }
    };

    useEffect(() => {
        if (isUpdateMeLoading) return;
        if (isUpdateMeError && updateMeError) {
            showErrorToast(updateMeError, {
                message: `Erreur lors de la mise à jour de vos informations`
            });
            return;
        }
        if (isUpdateMeSuccess && updateMeData) {
            showApiToast(updateMeData, {
                successMessage: `Informations mises à jour avec succès`,
                errorMessage: `Erreur lors de la mise à jour de vos informations`
            });
            return;
        }
    }, [isUpdateMeLoading, isUpdateMeError, isUpdateMeSuccess, updateMeError, updateMeData]);

    return {
        handleUpdateUser
    };
};
